// extracted by mini-css-extract-plugin
export default {"qr-backdrop":"GroupShare_qr-backdrop__5Edo7"};